import {Slider} from '@material-ui/core'

import {Theme, withStyles} from '../../theme'

const height = 4

export default withStyles(
  (theme: Theme) => ({
    thumb: {
      width: 24,
      height: 24,
      border: `1px solid ${theme.go.schemes.colors.system.Line}`,
      backgroundColor: theme.go.schemes.colors.system.BgMain,
      marginLeft: -10,
      marginTop: -10,
    },
    root: {
      height,
      color: theme.go.schemes.colors.system.ControlMinor,
    },
    rail: {
      height,
      opacity: 1,
    },
    track: {
      height,
      backgroundColor: theme.go.schemes.colors.system.ControlMain,
    },
    mark: {
      height,
      opacity: 1,
      backgroundColor: theme.go.schemes.colors.system.BgMain,
      borderRadius: 'initial',
    },
    valueLabel: {
      left: 'auto',
    },
    markLabel: {
      color: theme.go.schemes.colors.system.TextMinor,
      fontSize: theme.typography.fontSize,
    },
    [theme.breakpoints.down('sm')]: {
      markLabel: {
        fontSize: 12,
      },
    },
  }),
  {name: 'LFSlider'},
)(Slider)
